"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Unstable_TrapFocus.default;
  }
});

var _Unstable_TrapFocus = _interopRequireDefault(require("./Unstable_TrapFocus"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/Unstable_TrapFocus/index.js
// module id = 380
// module chunks = 0